/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { PersonalizedHeader, DynamicHeader } from "../components";

export default function CategoryHeader({
  product,
  visitorName,
  renderCatNameOnly = false
}) {
  const { catName, subCatName } = product;
  const title = renderCatNameOnly ? `${catName}` : `${catName} - ${subCatName}`;
  return (
    <header className="series">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2
              style={{
                textTransform: "capitalize"
              }}
            >
              {title}
            </h2>
            {visitorName ? (
              <PersonalizedHeader name={visitorName} />
            ) : (
              <DynamicHeader firstCat={catName} lastCat={subCatName} />
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
